import { Component, OnInit } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { MapsAddStuffService } from '../../maps-add-stuff.service';
import { SegmentEvents } from '../../constants/SegmentEvents';

@Component({
  selector: 'app-add-pin',
  templateUrl: './add-pin.component.html',
  styleUrls: ['./add-pin.component.less']
})

export class AddPinComponent implements OnInit {

  constructor(public mapsAddStuffService: MapsAddStuffService) { }

  mapClickListener: any;
  addPinInfoWindow: any;
  addPinLatLng: any;
  isSaving: boolean = false;
  addNewPinMode: boolean = false;
  addPinTypeInfowindow: any;
  addPinFlowSubscription: Subscription;
  editMode: boolean = false;
  markerColor: any;

  //Events Subscriptions
  addPinAfterSignupSubscription: any;
  editPinSubscription: any;
  removePinSubscription: any;
  movePinSubscription: any;
  closeAddPinFlowSubscription: any;

  ngOnInit() {
    let w = (<any>window);
    this.addPinFlowSubscription = this.mapsAddStuffService.addPinFlowActiveStream.subscribe((start)=> {
      if(start) {
        this.beginAddPinFlow();
      }
    });
    this.addPinAfterSignupSubscription = w.Events.subscribe('addPinAfterSignup', (data)=>{
      if(data) {
        this.isSaving = true;
        if(this.isSaving) {
          w.Events.publish('startLoadingWhite');
        }
        this.mapsAddStuffService.addPin(data).subscribe((response)=>{
          this.isSaving = false;
          this.successDone(response);
          w.Events.publish('endLoadingWhite',);
          this.closeAddPinFlow();
        },(error)=>{
          this.isSaving = false;
          w.Events.publish('endLoadingWhite', {
            hasError: true
          });
          w.Events.publish('error', error);
        })
      }
    });
  }

  ngAfterViewInit() {
    let w = (<any>window);
    this.editPinSubscription = w.Events.subscribe('editPin',(data)=>{
      this.editMode = true;
      this.addPinLatLng = w.pins.getLatLng(data.geom);
      this.addPin(data);
    });

    this.removePinSubscription = w.Events.subscribe('removePin',(data)=>{
      this.mapsAddStuffService.deletePin(data.pinId).subscribe((response)=>{
        this.isSaving = false;
        w.contextualInfoWindow.closeAllInfoWindows();
        w.pins.deleteSinglePin(data.pinId);
        this.closeAddPinFlow();
      },(error)=>{
        this.isSaving = false;
        if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
          w.Events.publish('usageLimitErrorFeature', 'save-marker');
        }
        w.Events.publish('error', error);
      });
    });

    this.movePinSubscription = w.Events.subscribe('movePin',(data)=>{
      w.Events.publish('startLoadingGrey');
      this.mapsAddStuffService.editPin(data, data.pinId).subscribe((response: any)=> {
        this.isSaving = false;
        w.pins.deleteSinglePin(data.pinId);
        this.successDone(response);
        w.Events.publish('endLoadingGrey',{
        });
      },(error)=>{
        this.isSaving = false;
        w.Events.publish('endLoadingGrey',{
          hasError: true
        });
        if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
          w.Events.publish('usageLimitErrorFeature', 'save-marker');
        }
        w.Events.publish('error', error);
      });
    });

    this.closeAddPinFlowSubscription = w.Events.subscribe('closeAddPinFlow', (value)=>{
      this.closeAddPinFlow();
    });
  }

  beginAddPinFlow() {
    this.addNewPinMode = true;
    let w = (<any>window);
    w.contextualInfoWindow.closeAllInfoWindows();
    w.addClass(w.domBody, 'add-pin');
    w.map.setOptions({ draggableCursor:'crosshair' });
    this.mapClickListener = w.google.maps.event.addListener(w.map,'click',(e)=>{
      if(!this.addPinInfoWindow) {
        this.addPinLatLng = e.latLng;
        this.addPin();
        w.map.setOptions({ draggableCursor:'' });
      }
    });
  }

  addPin(data?) {
    let w = (<any>window);
    w.contextualInfoWindow.closeAllInfoWindows();
    this.addPinInfoWindow = new w.SnazzyInfoWindow({
      content: this.getAddPinContentString(data || {}),
      position: this.addPinLatLng,
      map: w.map,
      placement: 'top',
      closeOnMapClick: false,
      wrapperClass: 'infowindow-add-pin-overriding',
      pointer: '8px',
      showCloseButton: false,
      callbacks: {
        afterOpen: ()=>{
          this.addInputListener();
          this.saveButtonListener(data && data.pinId);
          this.cancelButtonListener();
        }
      },
      edgeOffset: {
        top: 110
      }
    });
    this.addPinInfoWindow.open();
  }

  addInputListener() {
    let w = (<any>window),
      addPinInput = document.getElementById('add-pin-input'),
      pinTypeInput = document.getElementById('pin-type');
    if(addPinInput) {
      Observable.fromEvent(addPinInput, 'input')
        .debounceTime(100)
        .subscribe((e: any) => {
            if((<HTMLTextAreaElement>e.target).value.length >= 1) {
              w.removeClass(document.getElementById('pin-input-container'), 'required')
            }
        });
      addPinInput.focus();
    }
    if(pinTypeInput) {
      pinTypeInput.addEventListener('click', (e:any) => {
        if(this.addPinTypeInfowindow && this.addPinTypeInfowindow.isOpen()) {
          this.addPinTypeInfowindow.close();
        } else {
          this.showPinTypeDropdown();
        }
      });
    }
  }

  showPinTypeDropdown() {
    let w = (<any>window);
    if(!this.addPinTypeInfowindow) {
      this.addPinTypeInfowindow = new w.SnazzyInfoWindow({
        content: this.getPinTypeDropdownContent(),
        position: this.addPinLatLng,
        map: w.map,
        placement: 'top',
        closeOnMapClick: false,
        wrapperClass: 'infowindow-add-pin-type-overriding',
        pointer: false,
        showCloseButton: false,
        offset: {
          top: '164px',
          left: '145px'
        },
        callbacks: {
          afterOpen: ()=>{
            this.addPinTypeDropdownListner();
          }
        }
      });
    }
    this.addPinTypeInfowindow.open();
  }

  getAddPinContentString(data) {
    let w = (<any>window);
    let pin : any;
    pin = w.MARKER_IMAGES_2X.find((obj) => {
      if(data.markerColor === obj.MARKER_COLOR && data.pinType === obj.MARKER_PIN_TYPE) {
        return obj
      }
    })
    return '<div class="infowindow-add-retailer" onclick="base.stopProp(event);">'+
      '<label>Name</label><br />' +
      '<div class="input-container" id="pin-input-container">' +
      '<div class="required-text">Required</div>' +
      '<input type="text" class="no-outline" value="'+ (data.text ? data.text:'') + '" onfocus="this.value = this.value;" id="add-pin-input" autofocus />' +
      '<div class="select-field-content small-select-field dropdown-pin-type" pinType="'+ (data.pinType? data.pinType : 4)+'" id="pin-type"><img class="marker-image" id="marker-type-image" src="'+ (data.pinType ? pin.SMALL_MARKER : w.MARKER_IMAGES_2X[3].SMALL_MARKER)+'"></div>' +
      '</div>' +
      '<div class="button-container"><a class="btn btn-save" id="btn-save-pin">Save</a></div>' +
      '<a class="cancel" id="btn-cancel-pin">Cancel</a></div>' +
      '</div>';
  }

  getPinTypeDropdownContent() {
    let html = '',
    w = (<any>window);
    let pinsLength = w.MARKER_IMAGES_2X.length;
    for(let i = 0; i < pinsLength; i++) {
      html += '<div class="pin-type-option" data-pinType="' + ((i % 4) + 1) + '"><img class="marker-image" src="'+ w.MARKER_IMAGES_2X[i].SMALL_MARKER +'"></div>';
    }
    return '<div class="infowindow-add-pin-type" onclick="base.stopProp(event);">'+ html + '</div>';
  }

  addPinTypeDropdownListner() {
    let pinTyperEls = document.getElementsByClassName('pin-type-option'),
    w = (<any>window);
    for(let i=0; i < pinTyperEls.length; i++) {
      pinTyperEls[i].addEventListener('click', (e:any) => {
        this.markerColor = w.MARKER_IMAGES_2X[i].MARKER_COLOR;
        let img = document.getElementById('marker-type-image');
        let pinTypeDiv = document.getElementById('pin-type');
        let pinType = e.target.getAttribute('data-pinType');
        if(!pinType || pinType === null) {
          pinType = e.target.parentElement.getAttribute('data-pinType');
        }
        img.setAttribute('src', w.MARKER_IMAGES_2X[i].SMALL_MARKER);
        pinTypeDiv.setAttribute('pinType', pinType);
        this.addPinTypeInfowindow.close();
      });
    }
  }

  saveButtonListener(pinId?) {
    let w = (<any>window),
        saveButton = document.getElementById('btn-save-pin');
    saveButton.addEventListener('click',(e:any)=> {
      let addPinInput = document.getElementById('add-pin-input');
      if((<HTMLTextAreaElement>addPinInput).value.length === 0) {
        w.addClass(document.getElementById('pin-input-container'), 'required');
        addPinInput.focus();
        return;
      }
      if(!this.isSaving) {
        this.isSaving = true;
        if(saveButton) {
          saveButton.innerHTML = 'Please Wait...';
          saveButton.setAttribute('disabled', 'true');
          saveButton.classList.add('please-wait-state');
        }
        if(this.editMode) {
          w.Events.publish('startLoadingGrey');
        } else {
          w.Events.publish('startLoadingWhite');
        }
        let input = <HTMLInputElement>document.getElementById('add-pin-input'),
          dropdown = document.getElementById('pin-type'),
          //MapPin
          data = {
            text: input.value,
            pinType: dropdown.getAttribute('pinType'),
            markerColor: this.markerColor ? this.markerColor : '#E30613',
            geom: w.getPointGeoJson(this.addPinInfoWindow._position)
          },
          onAddSuccess = (response: any)=> {
            this.isSaving = false;
            if(saveButton) {
              saveButton.innerHTML = 'Save';
              saveButton.removeAttribute('disabled');
              saveButton.classList.remove('please-wait-state');
            }
            this.successDone(response);
            w.Events.publish('segment', {
              name: SegmentEvents.mapMarkerAdded,
              data: {
                marker_id: response.pinId,
              }
            });
            w.Events.publish('endLoadingWhite');
            this.closeAddPinFlow();
          },
          onEditSuccess = (response: any)=> {
            this.isSaving = false;
            if(saveButton) {
              saveButton.innerHTML = 'Save';
              saveButton.removeAttribute('disabled');
              saveButton.classList.remove('please-wait-state');
            }
            w.pins.deleteSinglePin(pinId);
            this.successDone(response);
            w.Events.publish('endLoadingGrey');
            this.closeAddPinFlow();
          },
          onError = (error)=> {
            this.isSaving = false;
            if(saveButton) {
              saveButton.innerHTML = 'Save';
              saveButton.removeAttribute('disabled');
              saveButton.classList.remove('please-wait-state');
            }
            if(this.editMode) {
              w.Events.publish('endLoadingGrey', {
                hasError: true
              });
            } else {
              w.Events.publish('endLoadingWhite', {
                hasError: true
              });
            }
            this.closeAddPinFlow();
            if(error.status === 403 && error.error.apiErrorCode === 'USAGE_LIMIT_EXCEEDED') {
              w.Events.publish('usageLimitErrorFeature', 'save-marker');
              w.Events.publish('updateFeatureExecutionAfterSignUp', {
                featureToExecute: 'save-marker',
                requestObject: data
              });
            }
            w.Events.publish('error', error);
          };
        pinId > 0 ? this.mapsAddStuffService.editPin(data, pinId).subscribe(onEditSuccess, onError)
          : this.mapsAddStuffService.addPin(data).subscribe(onAddSuccess, onError);
          this.markerColor = null;
      }
    });
  }

  successDone(response) {
    let w = (<any>window);
    w.pins.addNewPin({
      addNewPinOnly: true,
      id: response.pinId,
      position: w.pins.getLatLng(response.geom),
      mapPin: response
    });
    this.closeAddPinFlow();
  }

  closeAddPinFlow() {
    let w = (<any>window);
    if(w.map) {
      this.addNewPinMode = false;
      w.map.setOptions({ draggableCursor:'' });
      w.removeClass(w.domBody, 'add-pin');
      w.google.maps.event.removeListener(this.mapClickListener);
      if(this.addPinInfoWindow) {
        this.addPinInfoWindow.close();
        delete this.addPinInfoWindow;
      }
      if(this.addPinTypeInfowindow) {
        this.addPinTypeInfowindow.close();
        delete this.addPinTypeInfowindow;
      }
      this.mapsAddStuffService.addPinFlowActiveSource.next(false);
    }
  }

  cancelButtonListener() {
    let w = (<any>window);
    document.getElementById('btn-cancel-pin').addEventListener('click',(e:any)=> {
      this.closeAddPinFlow();
      this.markerColor = null;
    });
  }

  removeSubscriptions() {
    this.addPinFlowSubscription && this.addPinFlowSubscription.unsubscribe();

    this.addPinAfterSignupSubscription && this.addPinAfterSignupSubscription.unsubscribe() ;
    this.editPinSubscription && this.editPinSubscription.unsubscribe() ;
    this.removePinSubscription && this.removePinSubscription.unsubscribe() ;
    this.movePinSubscription && this.movePinSubscription.unsubscribe() ;
    this.closeAddPinFlowSubscription && this.closeAddPinFlowSubscription.unsubscribe() ;
  }

  ngOnDestroy() {
    this.removeSubscriptions();
    this.closeAddPinFlow();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/maps-add-stuff/components/add-pin/add-pin.component.ts